import {Component, Input, OnInit} from '@angular/core';
import {NextLessonData, NextLessonProgress} from "../../../../types/interfaces";
import {MyGreenCountry} from "../../../../services/mygreencountry/my-greencountry";

@Component({
    selector: 'app-lesson-materials',
    templateUrl: './lesson-materials.component.html',
    styleUrls: ['./lesson-materials.component.scss'],
})
export class LessonMaterialsComponent implements OnInit {

    @Input() data: NextLessonProgress
    @Input() class: string = '';
    @Input() isCurrent: boolean = false;
    @Input() animated: boolean = false;
    @Input() isFuture: boolean = false;
    @Input() isPast: boolean = false;
    @Input() groupId: number|null = null;
    @Input() hideEducationMaterials: boolean = false;

    constructor(public myGcService: MyGreenCountry,) {
    }

    ngOnInit() {
    }

    openUrl(url: string | undefined, selfStudy:boolean = false) {
        if (url) {
            if (selfStudy && this.groupId && this.data.lessonNumber){
                this.myGcService.cleanCacheEBook(this.groupId, this.data.lessonNumber)
                    .subscribe({
                        next: (response) => {
                        },
                        error: (error) => {
                        },
                        complete: () => {
                        }
                    })
            }

            this.myGcService.openUrl(url)
        }
    }
}
